<template>
  <div class="login-container">
    <el-card style="width: 25%; height: 40%" shadow="always" class="login-card">
      <img
        style="width: 100px"
        src="../../assets/img/logo.png"
        alt="ZG-Blog logo"
      />
      <el-divider />
      <el-form :model="form" label-width="auto" style="max-width: 100%">
        <el-form-item>
          <el-input
            v-model="form.name"
            style="max-width: 100%"
            placeholder="账号/手机号/邮箱"
            size="large"
            clearable
          >
            <template #prefix>
              <el-icon size="20"><User /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.passwd"
            style="max-width: 100%"
            placeholder="密码"
            type="password"
            size="large"
            show-password
          >
            <template #prefix>
              <el-icon size="20"><Lock /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox-group v-model="form.type" style="margin-left: 4%">
            <el-checkbox value="1" name="type" style="color: #ffffff">
              十天内免登录
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
          <el-button
            class="loginButton"
            style="width: 100%; height: 50px"
            type="primary"
            round
            size="large"
            @click="onShow"
            :loading="isLoading"
          >
            <el-icon :style="{ display: isHidden ? 'none' : 'block' }" size="40"
              ><Right
            /></el-icon>
          </el-button>
        </el-form-item>
        <el-row :gutter="20" style="margin: 10px">
          <el-col :span="10"
            ><el-link style="color: #ffffff; font-size: 15px; font-weight: bold"
              >忘记密码？</el-link
            ></el-col
          >
          <el-col :span="2"></el-col>
          <el-col :span="2"></el-col>
          <el-col :span="10"
            ><el-link style="color: #ffffff; font-size: 15px; font-weight: bold"
              >去注册</el-link
            ></el-col
          >
        </el-row>
      </el-form>
    </el-card>
  </div>
  <BackgroundImage />
</template>  
<script>
import { reactive, ref } from "vue";
import Vcode from "vue3-puzzle-vcode";
import { ElLoading, ElMessage } from "element-plus";
export default {
  components: { Vcode },
  setup() {
    const form = reactive({
      name: "",
      passwd: "",
      type: [],
    });
    const isShow = ref(false);
    const isLoading = ref(false);
    const isHidden = ref(false);
    const onShow = () => {
      isLoading.value = true;
      isShow.value = true;
      isHidden.value = true;
    };

    const onClose = () => {
      isLoading.value = false;
      isShow.value = false;
      isHidden.value = false;
    };

    const onSuccess = () => {
      onClose(); // 验证成功，手动关闭模态框
      // 登录逻辑
      if (form.passwd === "root") {
        const loading = ElLoading.service({
          lock: true,
          text: "正在创建地球Online……",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout(() => {
          loading.setText("正在构建地图模型……");
          setTimeout(() => {
            loading.setText("正在构建场景配置……");
            setTimeout(() => {
              loading.setText("正在加载NPC资源……");
              setTimeout(() => {
                loading.setText("正在生成角色……");
                setTimeout(() => {
                  loading.setText("正在前往目的地开始您的征程！！！");
                  setTimeout(() => {
                    loading.close();
                  }, 30000);
                }, 4000);
              }, 5000);
            }, 1000);
          }, 2000);
        }, 3000);
      } else {
        ElMessage({
          showClose: true,
          message: "账号或密码错误，请重新输入！！！",
          type: "error",
        });
      }
    };

    return {
      form,
      onShow,
      onSuccess,
      onClose,
      isShow,
      isLoading,
      isHidden,
    };
  },
};
</script>  
  
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../../assets/img/02.jpg"); /* 确保路径正确 */
  background-size: cover;
  background-position: center;
  text-align: center;
}
.login-card {
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px) saturate(180%);
  border-radius: 30px; /* 可根据需要调整圆角大小 */
  border: none;
}
.is-loading {
  font-size: 40px;
}
:deep(.el-input__wrapper) {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color))
    inset;
}
:deep(.el-input__inner) {
  border-bottom: 2px solid #ffffff; /* Element Plus的主题色，你可以根据需要调整颜色 */
  color: #ffffff;
}
:deep(.el-input__inner::placeholder) {
  color: #ffffff;
}
.loginButton {
  background-image: linear-gradient(to right, #3c4866 0%, #f7c3be 100%);
  border: none;
}
</style>    